// extracted by mini-css-extract-plugin
module.exports = {"modale":"AddStopGoBrandModal_modale__16NYN","containerButtons":"AddStopGoBrandModal_containerButtons__3J8Vs"};